
console.log('Vite ⚡️ Rails')
console.log('Visit the guide for more information: ', 'https://vite-ruby.netlify.app/guide/rails')

import "../controllers"
import * as Turbo from '@hotwired/turbo'
Turbo.start()

import * as ActiveStorage from "@rails/activestorage"
ActiveStorage.start()

// Import all channels.
const channels = import.meta.glob('./**/*_channel.js', { eager: true })

// Example: Import a stylesheet in app/frontend/index.css
// import '~/index.css'


import '~/src/notification'
import '~/src/offcanvas'
import '~/src/modal'

import * as bootstrap from 'bootstrap'

document.addEventListener("turbo:load", () => {
  let container = document.body.appendChild(document.createElement("div"));
  container.dataset.turboTemporary = true;

  new bootstrap.Tooltip(document.body, {
    selector: "[data-bs-toggle='tooltip']",
    container: container
  })
})
